// extracted by mini-css-extract-plugin
module.exports = {"Subheading":"Subheading_Subheading__UzK_l","Subheading___primary":"Subheading_Subheading___primary__BocvW","Subheading___secondary":"Subheading_Subheading___secondary__wtfhf"};